/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrameworkOptionDto
 */
export interface FrameworkOptionDto {
    /**
     * 
     * @type {string}
     * @memberof FrameworkOptionDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof FrameworkOptionDto
     */
    frameworkName?: string;
}

/**
 * Check if a given object implements the FrameworkOptionDto interface.
 */
export function instanceOfFrameworkOptionDto(value: object): value is FrameworkOptionDto {
    return true;
}

export function FrameworkOptionDtoFromJSON(json: any): FrameworkOptionDto {
    return FrameworkOptionDtoFromJSONTyped(json, false);
}

export function FrameworkOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameworkOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'frameworkName': json['frameworkName'] == null ? undefined : json['frameworkName'],
    };
}

export function FrameworkOptionDtoToJSON(json: any): FrameworkOptionDto {
    return FrameworkOptionDtoToJSONTyped(json, false);
}

export function FrameworkOptionDtoToJSONTyped(value?: FrameworkOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkSlug': value['frameworkSlug'],
        'frameworkName': value['frameworkName'],
    };
}

